import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import useBreakpoint from '@hooks/breakpoint';

import { Skeleton } from 'fpay-ui';

const Head = styled.div`
  width: 100%;
  margin-top: 13px;
  margin-bottom: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px 0 21px;
`;

const Row = styled.div`
  background: #ffffff;
  width: 100%;
  height: 48px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px 0 21px;
`;

const widthSkeletonColumn = ['41px', '63px', '98px', '38px', '121px', '74px'];

const widthSkeletonColumnFalabella = ['98px', '121px', '121px', '98px'];

const TransactionTableSkeleton = ({ data, falabella }) => {
  const { medium } = useBreakpoint();

  const verificateRenderMedium = (index) => !([2, 3].indexOf(index) > -1 && medium);

  return (
    <div data-testid="transaction-table-skeleton">
      {falabella ? (
        <>
          <Head data-testid="transaction-table-skeleton-head">
            {widthSkeletonColumnFalabella.map((width, index) => (
              <Skeleton key={index} width={width} height="12px" type="" />
            ))}
          </Head>
          <div data-testid="transaction-table-skeleton-body">
            {data.map((elm, i) => (
              <Row key={i} data-testid={`transaction-table-skeleton-row${i}`}>
                {widthSkeletonColumnFalabella.map((width, index) => (
                  <Skeleton key={index} width={width} height="20px" type="" />
                ))}
              </Row>
            ))}
          </div>
        </>
      ) : (
        <>
          <Head data-testid="transaction-table-skeleton-head">
            {widthSkeletonColumn.map(
              (width, index) =>
                verificateRenderMedium(index) && (
                  <Skeleton key={index} width={width} height="12px" type="" />
                )
            )}
          </Head>

          <div data-testid="transaction-table-skeleton-body">
            {data.map((elm, i) => (
              <Row key={i} data-testid={`transaction-table-skeleton-row${i}`}>
                {widthSkeletonColumn.map(
                  (width, index) =>
                    verificateRenderMedium(index) && (
                      <Skeleton key={index} width={width} height="20px" type="" />
                    )
                )}
              </Row>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TransactionTableSkeleton;

TransactionTableSkeleton.propTypes = {
  data: PropTypes.array,
};

TransactionTableSkeleton.defaultProps = {
  data: [],
};
